import { render, staticRenderFns } from "./ReservationSetupParameter.vue?vue&type=template&id=5051b51f&scoped=true&"
import script from "./ReservationSetupParameter.vue?vue&type=script&lang=js&"
export * from "./ReservationSetupParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5051b51f",
  null
  
)

export default component.exports